import React, {FunctionComponent} from "react";
import './WizardStepQuittung.scss';
import {MscWizardProps} from "../../interfaces";

const WizardStepQuittung: FunctionComponent<MscWizardProps> = (props) => {


    return <div className="msc-anmeldung__wizard-step-four">
        <p className="msc-anmeldung__wizard-step-four__content">
            Sie sind fast fertig. Wir haben Ihnen eine Nachricht mit einem Link an die
            angegebene Nummer geschickt. Bitte klicken Sie auf den Link, um das Abonnement zu aktivieren.
        </p>
    </div>
};

export default WizardStepQuittung
